module.exports={
	"Form": "ObservationTagViewManifest",
	"Scope": "ObservationTag-View",
	"Descriptors":
	{
		"ObservationTagDetails.IDObservationTag":
		{
			"Name": "ID",
			"Hash": "ObsTagView-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "ObsTagIdentity",
				"Group": "ObsTagIdentity"
			}
		},
		"ObservationTagDetails.GUIDObservationTag":
		{
			"Name": "GUID",
			"Hash": "ObsTagView-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "ObsTagIdentity",
				"Group": "ObsTagIdentity"
			}
		},
		"ObservationTagDetails.Tag":
		{
			"Name": "Tag",
			"Hash": "ObsTagView-Tag",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "ObsTagIdentity",
				"Group": "ObsTagIdentity"
			}
		},
		"ObservationTagDetails.TagType":
		{
			"Name": "Tag Type",
			"Hash": "ObsTagView-TagType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "ObsTagConfig",
				"Group": "ObsTagConfig"
			}
		},
		"ObservationTagDetails.Description":
		{
			"Name": "Description",
			"Hash": "ObsTagView-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 6,
				"Section": "ObsTagConfig",
				"Group": "ObsTagConfig"
			}
		},
		"ObservationTagDetails.Global":
		{
			"Name": "Global",
			"Hash": "ObsTagView-Global",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "2",
				"Width": 2,
				"Section": "ObsTagConfig",
				"Group": "ObsTagConfig"
			}
		},
		"ObservationTagDetails.IDOrganization":
		{
			"Name": "Organization ID",
			"Hash": "ObsTagView-IDOrganization",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 3,
				"Section": "ObsTagAssociations",
				"Group": "ObsTagAssociations"
			}
		},
		"ObservationTagDetails.IDBidItem":
		{
			"Name": "Bid Item ID",
			"Hash": "ObsTagView-IDBidItem",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 3,
				"Section": "ObsTagAssociations",
				"Group": "ObsTagAssociations"
			}
		},
		"ObservationTagDetails.IDLineItem":
		{
			"Name": "Line Item ID",
			"Hash": "ObsTagView-IDLineItem",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 3,
				"Section": "ObsTagAssociations",
				"Group": "ObsTagAssociations"
			}
		},
		"ObservationTagDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "ObsTagView-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ObsTagAudit",
				"Group": "ObsTagAudit"
			}
		},
		"ObservationTagDetails.CreatingIDUser":
		{
			"Name": "Created By (User ID)",
			"Hash": "ObsTagView-CreatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ObsTagAudit",
				"Group": "ObsTagAudit"
			}
		},
		"ObservationTagDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "ObsTagView-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ObsTagAudit",
				"Group": "ObsTagAudit"
			}
		},
		"ObservationTagDetails.UpdatingIDUser":
		{
			"Name": "Updated By (User ID)",
			"Hash": "ObsTagView-UpdatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ObsTagAudit",
				"Group": "ObsTagAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ObsTagIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ObsTagIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Configuration",
			"Hash": "ObsTagConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Configuration",
					"Hash": "ObsTagConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Associations",
			"Hash": "ObsTagAssociations",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Associations",
					"Hash": "ObsTagAssociations",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "ObsTagAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "ObsTagAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
